<template>
  <div id="app" class="reading-app">
    <!-- <div class="banner">
      <img src="https://images.unsplash.com/photo-1507842217343-583bb7270b66?q=80&w=2070&auto=format&fit=crop"
        alt="Reading Banner">
    </div> -->
    <div class="banner" v-if="bannerArr.length > 0">
      <yd-slider autoplay="3000">
        <yd-slider-item v-for="(item, index) in bannerArr" :key="index">
          <div v-if="item.href.indexOf('https://hfgo.wo.cn/pay') != -1">
            <a v-if="isLiantong" :href="item.href"><img :src="item.coverImg" /></a>
            <a v-else href="javascript:;"><img :src="item.coverImg" /></a>
          </div>
          <div v-else>
            <a :href="item.href == '' ? 'javascript:;' : item.href"><img :src="item.coverImg" /></a>
          </div>
        </yd-slider-item>
      </yd-slider>
    </div>
    <div class="tabs">
      <span v-for="(tab, index) in tabs" :key="index" :class="{ 'active': activeTab === index }"
        @click="tabClick(tab, index)">
        {{ tab.categoryName }}
      </span>
    </div>

    <div class="news-list">
      <div class="news-item" v-for="(item, index) in news" :key="index" @click="detailUrl(item)">
        <img :src="item.coverImg" :alt="item.goodsName">
        <div class="news-content">
          <p class="news-title">{{ item.goodsName }}</p>
          <div class="news-meta">
            <!-- <span>阅读 {{ item.views }}</span> -->
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <FootTab></FootTab>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";

export default {
  components: {
    FootTab,
  },
  name: 'ReadingApp',
  data() {
    return {
      bannerArr: [],
      activeTab: 0,
      tabs: ['热门', '活动', '资讯'],
      news: [

      ]
    };
  },
  created() {
    this.http.getIndeBanner().then((res) => {
      this.bannerArr = res.data.data;
    });
    let data = {
      parentId: 16,
    }
    this.http.getListinfo(data).then((res) => {
      this.tabs = res.data.data;
      this.detail(res.data.data[0].categoryId)
    });
  },
  methods: {
    tabClick(item, index) {
      this.detail(item.categoryId)
      this.activeTab = index
    },
    detail(id) {
      this.http.getClassifyDet({
        "categoryId": id,
        "page": 1,
        "limit": 10
      }).then((res) => {
        console.log(res.data.data);
        this.news = res.data.data;
      });
    },
    detailUrl(item) {
      this.$router.push({
        path: "/infodetail",
        query: {
          id: item.id
        }
      })
    }
  },
};
</script>

<style scoped>
.reading-app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  max-width: 400px;
  margin: 0 auto;
  background-color: #f4f5f7;
}

.banner {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  margin: 12px;
}

.banner img {
  width: 100%;
  height: 130px;
  display: block;
}

.banner-text {
  position: absolute;
  top: 20px;
  left: 20px;
  color: white;
}

.banner-text .subtitle {
  font-size: 14px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  margin: 0;
  line-height: 1.5;
}

.banner-text .title {
  font-size: 48px;
  font-weight: bold;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  margin: 0 0 0 10px;
  line-height: 1;
}

.banner-text .date {
  position: absolute;
  top: 50px;
  left: 70px;
  font-size: 12px;
  transform: rotate(90deg);
  transform-origin: top left;
  white-space: nowrap;
}

.tabs {
  display: flex;
  justify-content: flex-start;
  padding: 0 12px;
  gap: 20px;
}

.tabs span {
  padding: 10px 0;
  cursor: pointer;
  color: #555;
  font-size: 18px;
  position: relative;
}

.tabs span.active {
  color: #000;
  font-weight: bold;
}

.tabs span.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: #4a90e2;
  border-radius: 2px;
}

.news-list {
  padding: 12px;
}

.news-item {
  display: flex;
  background-color: white;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 7px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.news-item img {
  width: 120px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 7px;
}

.news-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  text-align: left;
}

.news-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin-top: 0.5rem;
}
</style>